import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const sunrunAutomationsErrorTypeValues = [
  "AUTOMATION_FAILED",
  "HEALTH_CHECK_FAILED",
  "SQS_HEARTBEAT_MISCONFIGURED",
] as const;

const sunrunAutomationsErrorTypeSchema = z.enum(sunrunAutomationsErrorTypeValues);
export const SunrunAutomationsErrorType = sunrunAutomationsErrorTypeSchema.enum;
type SunrunAutomationsErrorType = z.infer<typeof sunrunAutomationsErrorTypeSchema>;

export type SunrunAutomationsErrors =
  | {
      errorType: typeof SunrunAutomationsErrorType.AUTOMATION_FAILED;
      data: {
        messageType: string;
        reason: string;
        automationId: string;
      };
    }
  | {
      errorType: typeof SunrunAutomationsErrorType.HEALTH_CHECK_FAILED;
      data: {
        messageType: string;
        reason: string;
        automationId: string;
      };
    }
  | {
      errorType: typeof SunrunAutomationsErrorType.SQS_HEARTBEAT_MISCONFIGURED;
      data: {
        heartbeatIntervalMs: number;
        visibilityTimeoutSeconds: number;
      };
    };

export const sunrunAutomationsErrorDetails: Record<SunrunAutomationsErrorType, ErrorDetails> = {
  [SunrunAutomationsErrorType.AUTOMATION_FAILED]: {
    sentryDescription: "Automation failed",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
  [SunrunAutomationsErrorType.HEALTH_CHECK_FAILED]: {
    sentryDescription: "Health check failed",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
  [SunrunAutomationsErrorType.SQS_HEARTBEAT_MISCONFIGURED]: {
    sentryDescription: "Heartbeat interval must be less than visibility timeout",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
};
